// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'vr';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M1.153 9.023c0-2.3 1.75-4.221 4.04-4.435l.958-.09a30.615 30.615 0 0 1 5.698 0l.956.09a4.457 4.457 0 0 1 4.042 4.437v.66a3.56 3.56 0 0 1-2.497 3.397 3.956 3.956 0 0 1-3.873-.877l-.713-.662a1.12 1.12 0 0 0-1.526.003l-.694.648a3.964 3.964 0 0 1-3.886.888 3.567 3.567 0 0 1-2.505-3.406z' />
    <path d='m12.71 6.665-1.171-.11a27 27 0 0 0-5.076 0l-1.173.11' />
  </g>
);

export const viewBox = '0 0 18 18';
